import React from 'react';
import {Form, Formik} from "formik";
import * as Yup from "yup";
import {Form as FormLayout} from "react-bootstrap";
import TextInput from "../../../../../Common/components/text-input";
import {formatFormTitle, FormikMultiFormSync} from "../../../../../../util/Helpers";
import SelectInput from "../../../../../Common/components/select-input";
import {FUNDING_SOURCES} from "../../../../data/FundingSources";

function ComplianceDetails(
    {
        dataKey,
        title,
        isEditable,
        initialValues: {
            complianceData = {}
        }
    }
) {
    const validationSchema = Yup.object({
        fundingSources: Yup.array().min(1, "Must select at least one").of(
            Yup.string().required("Required")
        ).required('Required'),
        investmentHistory12M: Yup.number().required('Required'),
        transferFrequencyPerMonth: Yup.number().required('Required'),
        transferTotalExpected: Yup.number().required('Required'),
    })

    const compiledInitialValues = {
        fundingSources: [],
        investmentHistory12M: "",
        transferFrequencyPerMonth: "",
        transferTotalExpected: "",
        ...complianceData
    }

    return (
        <div>
            <Formik validationSchema={validationSchema} initialValues={compiledInitialValues} validateOnMount={true}
                    enableReinitialize={true}>
                {({isValid}) =>
                    <Form>
                        <fieldset disabled={!isEditable}>
                            {formatFormTitle({title, isValid})}
                            <FormLayout.Row>
                                <TextInput
                                    label="Expected Annual Transfer*"
                                    name="transferTotalExpected"
                                    type="number"
                                />
                            </FormLayout.Row>
                            <FormLayout.Row>
                                <TextInput
                                    label="Expected Transfers*"
                                    name="investmentHistory12M"
                                    type="number"
                                />
                                <TextInput
                                    label="Past 12 Months*"
                                    name="transferFrequencyPerMonth"
                                    type="number"
                                />
                            </FormLayout.Row>
                            <FormLayout.Row>
                                <SelectInput
                                    label="Funding Sources*"
                                    name="fundingSources"
                                    options={FUNDING_SOURCES}
                                    multiple="multiple"
                                />
                            </FormLayout.Row>
                            <FormikMultiFormSync name={dataKey}/>
                        </fieldset>
                    </Form>
                }
            </Formik>
        </div>
    );
}

export default ComplianceDetails;